let VideoEditor = {
    version: "11.1.4.3",
    releaseDD: "27",
    releaseMM: "11",
    releaseYYYY: "2025",
    size: "201.45",
    platforms: "Windows 11, 10, 8.1, 8, 7, Vista, XP (no Mac OS/ Linux support)"
};

let VideoReMaker = {
    version: "8.1.4.3",
    releaseDD: "27",
    releaseMM: "11",
    releaseYYYY: "2025",
    size: "89.22",
    platforms: "Windows 11, 10, 8.1, 8, 7, Vista, XP (no Mac OS/ Linux support)"
};

let VideoConverter = {
    version: "14.1.4.3",
    releaseDD: "27",
    releaseMM: "11",
    releaseYYYY: "2025",
    size: "115.78",
    platforms: "Windows 11, 10, 8.1, 8, 7, Vista, XP (no Mac OS/ Linux support)"
};

let MediaPlayer = {
    version: "6.1.4.3",
    releaseDD: "27",
    releaseMM: "11",
    releaseYYYY: "2025",
    size: "151.56",
    platforms: "Windows 11, 10, 8.1, 8, 7, Vista, XP (no Mac OS/ Linux support)"
};

let AudioEditor = {
    version: "11.1.4.3",
    releaseDD: "27",
    releaseMM: "11",
    releaseYYYY: "2025",
    size: "79.83",
    platforms: "Windows 11, 10, 8.1, 8, 7, Vista, XP (no Mac OS/ Linux support)"
};

let AudioConverter = {
    version: "11.1.4.3",
    releaseDD: "27",
    releaseMM: "11",
    releaseYYYY: "2025",
    size: "83.90",
    platforms: "Windows 11, 10, 8.1, 8, 7, Vista, XP (no Mac OS/ Linux support)"
};

let AVSImageConverter = {
    version: "7.1.4.3",
    releaseDD: "27",
    releaseMM: "11",
    releaseYYYY: "2025",
    size: "53.43",
    platforms: "Windows 11, 10, 8.1, 8, 7, Vista, XP (no Mac OS/ Linux support)"
};

export {VideoEditor, VideoReMaker, VideoConverter, MediaPlayer, AudioEditor, AudioConverter, AVSImageConverter};